export const DEFAULT_LAYER_SETTING_VERSION = 1;

export class AbstractLayerSettingsState {
  // Increment this when making any changes to the structure of this class,
  // so that users will not end up using an out-of-date version from local
  // storage.
  version = DEFAULT_LAYER_SETTING_VERSION;
  persist = false;

  constructor(public opacity: number) {}
}
